<template>
  <div id="scroll" class="article-detail bg-white">
    <navbar />
    <article class="post" v-if="articleDetails">
      <header class="postH">
        <h2>{{thisArticle.title}}</h2>
        <div class="detail">
          <p>{{moment(articleDetails.created_at).format('YYYY/MM/DD')}}</p>
          <p class="category">{{$t(articleDetails.category)}}</p>
        </div>
      </header>
      <div class="postWrapper">
        <div class="contents">
          <figure v-if="articleDetails.blog_images"><img :src="articleDetails.blog_images.url" alt=""></figure>
          <figure v-else><img src="N/A" alt=""></figure>
          <div v-if="modifiedArticleHtml" v-html="modifiedArticleHtml"></div>
        </div>
      </div>
      <div class="back">
        <a @click="returnList" href="#scroll" v-smooth-scroll class="white_btn"><span>{{$t('一覧ページへ戻る')}}</span></a>
      </div>
    </article>
    <footerClient />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      currentlanguage: this.$route.params.lang,
      test: null
    }
  },
  components: {
    navbar,
    footerClient
  },
  created () {
    this.getArticleDetails(this.$route.params)
  },
  computed: {
    ...mapState('blogClient', ['articleDetails']),
    thisArticle: function () {
      switch (this.currentlanguage) {
        case 'ja':
          return this.articleDetails.blog_articles_details.日本語
        case 'en':
          return this.articleDetails.blog_articles_details.英語
        case 'zh-cn':
          return this.articleDetails.blog_articles_details.簡体字
        case 'zh-tw':
          return this.articleDetails.blog_articles_details.繁体字
        default:
          return this.articleDetails.blog_articles_details.日本語
      }
    },
    modifiedArticleHtml: function () {
      // Vimeoの埋め込みタグをスマホで表示するとプレイヤーが画面外にはみ出してしまうので埋め込みタグを調整用のdivタグで囲む
      return this.thisArticle?.body.replace(/(<iframe\s+[^>]*?src="https:\/\/player\.vimeo\.com[^>]*?>\s*<\/iframe>)/g, '<div class="movie-wrap">$1</div>')
    }
  },
  methods: {
    ...mapActions('blogClient', ['getArticleDetails']),
    iconBefore () {
      const buttonBefore = `.quoteTxt::before {background: url(${require('@/assets/img/client/icon-quote.png')}) left top no-repeat }`
      const style = document.createElement('style')
      style.type = 'text/css'
      this.$el.appendChild(style)
      style.innerHTML = buttonBefore
    },
    returnList () {
      this.$router.push({ name: 'Client Blog List' })
    }
  }
}
</script>
